import classes from "../classes";
import FormError from "./form-error";
import { Map } from "immutable";
import React from "react";

export default class PasswordResetForm extends React.PureComponent {

  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(e) {
    var { passwordReset } = this.props;
    e.preventDefault();
    passwordReset(this.refs.email.value);
  }

  render() {
    var { communications } = this.props;
    var loading = communications.getIn(["password-reset", "state"]) === "in progress";
    var errors = communications.getIn(["password-reset", "error"]) || Map();

    return (
      <form className="form--is-horizontal" onSubmit={this.onSubmit}>
        <div className="batch-g batch-g--padding batch-g--valign-center">

          <div className="batch-c-1-1 batch-c-md-1-4">
            <label htmlFor="email">
              Email Address
            </label>
          </div>

          <div className="batch-c-1-1 batch-c-md-3-4">
            <input className="form_input" id="email" name="email" placeholder="Email Address" ref="email" type="email" />

            <FormError error={errors.get("email")} name="Email Address" />
          </div>

          <div className="batch-c-1-1 batch-c-md-1-4" />

          <div className="batch-c-1-1 batch-c-md-3-4">
            <div className="form_action">
              <input
                className={classes({
                  "btn": true,
                  "btn--primary": true,
                  "btn--is-loading": loading,
                })}
                disabled={loading}
                type="submit"
                value={loading ? "Processing" : "Send A Reset Link"} />
            </div>
          </div>
        </div>
      </form>
    );
  }
}
